import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=54593a8e&functional=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=54593a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports